/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// @ts-ignore
import moment from 'moment';

import { FarthestAvailability } from '../types/tourAvailabilityResponses';

export function filterFarthestAvailabilityByTourId(
    farthestAvailability: FarthestAvailability
): FarthestAvailability {
    const farthestByTourId: FarthestAvailability = {};

    for (const tourId in farthestAvailability) {
        if (farthestAvailability.hasOwnProperty(tourId)) {
            const farthest = moment(farthestAvailability[tourId]);
            const oneYearFromToday = moment().clone().add(1, 'year');

            if (farthest.isAfter(oneYearFromToday)) {
                farthestByTourId[tourId] = oneYearFromToday.format('YYYY-MM-DD');
            } else {
                farthestByTourId[tourId] = farthestAvailability[tourId];
            }
        }
    }

    return farthestByTourId;
}
